import axios from 'axios';
import { authHeader } from '../helpers';

const axiosInstance = axios.create({
  baseURL: ''
});

// GLOBAL RESPONSE HANDLER
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      localStorage.removeItem('user');

      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }

      // STOP propagation completely
      return new Promise(() => {});
    }

    return Promise.reject(error);
  }
);

export const portfolioOverviewService = {
  getPortfolioOverview,
  getPortfolioAccounts
};

async function getPortfolioOverview({ clientId, fromDate, toDate }) {
  const requestOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    withCredentials: true
  };

  const response = await axiosInstance.post(
    '/api/dataview/client-portfolios',
    {
      clientId,
      fromDate,
      toDate
    },
    requestOptions
  );

  return response.data;
}

async function getPortfolioAccounts({ accountIds, date }) {
  const requestOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    withCredentials: true
  };

  const response = await axiosInstance.post(
    '/api/dataview/portfolio-accounts',
    {
      accountIds,
      date
    },
    requestOptions
  );

  return response.data;
}
